<template>
  <div class="input-number-range">
    <el-button
      class="input-number-range__minus"
      icon="el-icon-minus"
      :class="{active: active}"
      :disabled="!minEnable"
      :style="{height: height, width: height}"
      @click="decrease"
    >
    </el-button>
    <div class="input-number-range__value"
         :style="{height: height}">
      <div v-if="false">
      {{ this.minValue }}
        <span class="bold input-number-range__value__hyphen">
          -
        </span>
      </div>
      {{formattedValue}} {{ unit }}
    </div>
    <el-button
      class="input-number-range__plus"
      icon="el-icon-plus"
      :style="{height: height, width: height}"
      :class="{active: active}"
      :disabled="!maxEnable"
      @click="increase"
    >
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'InputNumberRange',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 26,
    },
    height: {
      type: String,
      default: '46px',
    },
    value: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    minValue() {
      if (this.value - this.step < this.min) return this.min;
      return this.value - this.step;
    },
    maxEnable() {
      return !this.max || this.value < this.max;
    },
    minEnable() {
      return !this.min || this.value - this.step > this.min;
    },
    formattedValue() {
      return this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
  methods: {
    increase() {
      if (this.max !== undefined && this.value + this.step <= this.max) {
        this.$emit('input', this.value + this.step);
      } else if (this.max === undefined) this.$emit('input', this.value + this.step);
    },
    decrease() {
      if (this.min !== undefined && this.value - this.step > this.min) {
        this.$emit('input', this.value - this.step);
      } else if (this.min === undefined) this.$emit('input', this.value - this.step);
    },
  },

};
</script>

<style scoped lang="scss">
  .active{
    background-color: rgba(28, 219, 161, 0.1);
    border-color: $--color-primary;
  }
  .input-number-range {
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    color: $--color-secondary;

    &__minus {
      color: $--color-secondary;
      font-size: 15px;
      box-shadow: none;
      padding: 3px;
      border-radius: $--border-radius-base 0 0 $--border-radius-base;
      border: 1px solid $--color-secondary;
    }

    &__value{
      font-size: 15px;
      display: flex;
      place-items: center;
      align-items: center;
      text-align: center;
      padding: 0 10px;
      border-top: 1px  solid $--color-secondary;
      border-bottom: 1px  solid $--color-secondary;
      &__hyphen{
        padding: 0 10px;
      }
    }

    &__plus {
      color: $--color-secondary;
      font-size: 15px;
      padding: 3px;
      box-shadow: none;
      border-radius:  0  7px 7px 0;
      border: 1px solid $--color-secondary;
    }
  }
</style>
